const SwingDance = {
    name: "Swing Dance",
    bpm: 96,
    signature: "4/4",
    introMeasures: 4,
    pattern: [

    ]
};

export default SwingDance;